import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { Brand } from "../components/Brand";
import { Download, Loader2, ArrowLeft, CheckCircle2 } from "lucide-react";

export default function Invoice() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [inv, setInv] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => { api.get(`/billing/invoice/${id}`).then((r) => setInv(r.data)).catch(() => setErr(true)); }, [id]);

  if (err) return <div className="min-h-screen grid place-items-center text-ink-soft">Invoice not found.</div>;
  if (!inv) return <div className="min-h-screen grid place-items-center"><Loader2 className="h-8 w-8 animate-spin text-brand" /></div>;

  return (
    <div className="min-h-screen bg-background">
      <header className="glass border-b border-slate-200 px-5 h-16 flex items-center justify-between print:hidden">
        <Brand />
        <div className="flex gap-2">
          <button onClick={() => navigate(-1)} className="inline-flex items-center gap-2 text-sm font-bold text-ink-soft hover:text-ink px-3 py-2"><ArrowLeft className="h-4 w-4" /> Back</button>
          <button data-testid="invoice-download" onClick={() => window.print()} className="inline-flex items-center gap-2 text-sm font-bold text-white bg-brand hover:bg-brand-hover px-4 py-2 rounded-full transition-colors"><Download className="h-4 w-4" /> Download</button>
        </div>
      </header>
      <div className="max-w-2xl mx-auto px-5 py-10 fade-up">
        <div className="bg-white rounded-2xl border border-slate-200 shadow-card p-8">
          <div className="flex items-start justify-between pb-6 border-b border-slate-200">
            <div><Brand /><div className="text-xs text-ink-faint mt-2">Mock2Crack Technologies<br />billing@mock2crack.ai</div></div>
            <div className="text-right">
              <div className="font-heading font-bold text-xl text-ink">INVOICE</div>
              <div className="num text-sm text-brand font-semibold">{inv.id}</div>
              <span className="inline-flex items-center gap-1 mt-2 text-xs font-bold px-2.5 py-1 rounded-full bg-emerald-100 text-emerald-700"><CheckCircle2 className="h-3 w-3" /> {inv.status.toUpperCase()}</span>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4 py-6 text-sm">
            <div><div className="text-xs font-bold uppercase tracking-wider text-ink-faint mb-1">Billed To</div><div className="font-semibold text-ink">{inv.billed_to}</div></div>
            <div className="text-right"><div className="text-xs font-bold uppercase tracking-wider text-ink-faint mb-1">Date</div><div className="num text-ink">{new Date(inv.date).toLocaleDateString()}</div></div>
          </div>
          <table className="w-full text-sm">
            <thead><tr className="text-left text-xs font-bold uppercase tracking-wider text-ink-faint border-y border-slate-200"><th className="py-2.5">Description</th><th className="py-2.5 text-right">Amount</th></tr></thead>
            <tbody><tr className="border-b border-slate-100"><td className="py-3 text-ink">{inv.description}</td><td className="py-3 text-right num text-ink">{inv.currency}{inv.amount.toLocaleString()}</td></tr></tbody>
          </table>
          <div className="flex justify-end mt-4">
            <div className="w-56">
              <div className="flex justify-between text-sm py-1"><span className="text-ink-soft">Subtotal</span><span className="num text-ink">{inv.currency}{inv.amount.toLocaleString()}</span></div>
              <div className="flex justify-between text-sm py-1"><span className="text-ink-soft">Tax</span><span className="num text-ink">{inv.currency}0</span></div>
              <div className="flex justify-between font-bold pt-2 mt-1 border-t border-slate-200"><span className="text-ink">Total Paid</span><span className="num text-brand">{inv.currency}{inv.amount.toLocaleString()}</span></div>
            </div>
          </div>
          <div className="text-center text-xs text-ink-faint mt-8 pt-4 border-t border-slate-200">Payment method: {inv.payment_method} · Thank you for your business!<br />© 2026 Mock2Crack · Simulated transaction</div>
        </div>
      </div>
    </div>
  );
}
